import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MessageCircle, Calendar, ArrowRight } from 'lucide-react';

/**
 * Bottom CTA — displayed above the footer on every page.
 * "Ready to travel in comfort?" + Book Now + WhatsApp
 */
export const BottomCTA = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const lang = (i18n.language || 'en').split('-')[0];

  const goToBooking = (e) => {
    e.preventDefault();
    const el = document.getElementById('booking');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate(`/${lang}#booking`);
      setTimeout(() => {
        const t = document.getElementById('booking');
        if (t) t.scrollIntoView({ behavior: 'smooth' });
      }, 400);
    }
  };

  const whatsappMsg = encodeURIComponent(t('whatsapp.prefill_message'));
  const whatsappHref = `https://wa.me/351932651940?text=${whatsappMsg}`;

  return (
    <section
      className="relative overflow-hidden bg-gradient-to-br from-amber-500 via-amber-600 to-amber-700 py-16 md:py-20"
      data-testid="bottom-cta"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            'radial-gradient(circle at 15% 30%, rgba(255,255,255,0.4) 0%, transparent 45%), radial-gradient(circle at 85% 70%, rgba(0,0,0,0.25) 0%, transparent 45%)',
        }}
      />
      <div className="container relative mx-auto max-w-3xl px-4 text-center">
        <h2
          className="mb-4 font-serif text-3xl font-bold leading-tight text-black md:text-5xl"
          data-testid="bottom-cta-title"
        >
          {t('bottom_cta.title')}
        </h2>
        <p className="mb-8 text-base text-black/80 md:text-lg">
          {t('bottom_cta.subtitle')}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <a
            href="#booking"
            onClick={goToBooking}
            className="group inline-flex items-center gap-2 rounded-full bg-black px-7 py-4 text-sm font-bold text-white shadow-2xl hover:bg-gray-900 hover:scale-[1.03] transition-all md:text-base"
            data-testid="bottom-cta-book"
          >
            <Calendar className="h-5 w-5" />
            {t('bottom_cta.book')}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-green-600 px-7 py-4 text-sm font-bold text-white shadow-2xl hover:bg-green-700 hover:scale-[1.03] transition-all md:text-base"
            data-testid="bottom-cta-whatsapp"
          >
            <MessageCircle className="h-5 w-5" />
            {t('bottom_cta.whatsapp')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default BottomCTA;
